// extracted by mini-css-extract-plugin
export default {"containerFooter":"Footer_containerFooter__cpg6+","socialIcons":"Footer_socialIcons__JZqJ0","spacer":"Footer_spacer__olBei"};